import React, { Component } from "react";
import LandingPageLayout from "../layout/LandingPageLayout";
import LandingPageQuizWantSale from "./quiz/LandingPageQuizWantSale";
import LandingPageQuizQuestionBase from "./quiz/LandingPageQuizQuestionBase";
import LandingPageQuizResultBase from "./quiz/LandingPageQuizResultBase";
import LandingPageQuizForm from "./quiz/LandingPageQuizForm";

// images
import arrowDown from "../../../../img/landing-page/arrow-blue.svg";
import shop from "../../../../img/landing-page/quiz/shop.png";
import airplaneWorld from "../../../../img/landing-page/quiz/airplane-world.png";

class LandingPageQuiz extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentStep: 1
		};
	}

	goDown = () => {
		window.scroll({
			top: window.innerHeight - 50,
			behavior: "smooth"
		});
	};

	goToAverageMiles = () => {
		let averageMiles = document.getElementById("average-miles");
		window.scroll({
			top: averageMiles.offsetTop - 35,
			behavior: "smooth"
		});
	};

	submitted = () => {
		this.setState({
			currentStep: 2
		});

		return this.props.submitted();
	};

	setBackgroundColor() {
		switch (this.state.currentStep) {
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
			case 7:
			case 10:
			case 13:
				return "blue";
			case 6:
			case 8:
			case 9:
			case 11:
			case 12:
				return "pink";
			default:
				return "";
		}
	}

	setCurrentStep(step) {
		this.setState({
			currentStep: step
		});
	}

	getCurrentStepComponent() {
		switch (this.state.currentStep) {
			case 1:
				return <LandingPageQuizWantSale next={() => this.setCurrentStep(13)} />;
			case 2: // CREDIT CARD
				return (
					<LandingPageQuizQuestionBase
						yes={() => this.setCurrentStep(3)}
						no={() => this.setCurrentStep(6)}
						text="Toda vez que a gente faz uma compra no cartão de crédito, acumula pontos que podem ser trocados por milhas aéreas ou outros produtos. Simples, né? Por isso, a primeira coisa que queremos saber é:"
						title="VOCÊ USA CARTÃO DE CRÉDITO?"
						icon="shop"
					/>
				);
			case 3: // Credit card YES
				return (
					<LandingPageQuizQuestionBase
						yes={() => this.setCurrentStep(4)}
						no={() => this.setCurrentStep(9)}
						text="Trocar os pontos do cartão por milhas aéreas é bem fácil. É só se cadastrar no programa de fidelidade de uma companhia aérea e fazer a transferência. Agora, uma pergunta importante:"
						title="VOCÊ TEM CADASTRO EM UM PROGRAMA DE FIDELIDADE?"
						icon="read-learn"
					/>
				);
			case 4: // Credit card YES -> Tem cadastro em plano de fidelidade?
				return (
					<LandingPageQuizQuestionBase
						yes={() => this.setCurrentStep(5)}
						no={() => this.setCurrentStep(12)}
						text="Você sabia que pode ganhar dinheiro vendendo suas milhas? Este é um jeito muito fácil e seguro de fazer dinheiro aproveitando milhas que você tem e, às vezes, nem sabe. Então, responda pra gente:"
						title="Você gostaria de vender milhas e ganhar dinheiro?"
						icon="airplane-world"
					/>
				);
			case 5: // Credit card YES -> Tem cadastro em plano de fidelidade? YES
				return (
					<LandingPageQuizResultBase
						text="Você sabe dar valor ao dinheiro e tem um grande potencial para lucrar com suas milhas."
						strongText="Que tal conferir se já tem pontos acumuladas no seu cartão de crédito ou milhas no seu programa de fidelidade e ver quanto elas estão valendo na MaxMilhas?"
						buttonText="VER QUANTO VALEM MINHAS MILHAS"
						buttonAction={() => this.goToAverageMiles()}
						icon="airplane-fullwidth"
					/>
				);
			case 6: // Credit card NO
				return (
					<LandingPageQuizQuestionBase
						yes={() => this.setCurrentStep(7)}
						no={() => this.setCurrentStep(8)}
						text="Usar o cartão de crédito é só uma das formas de acumular pontos e trocá-los por vários benefícios, como milhas aéreas."
						title="Você tem interesse em saber mais sobre como ganhar dinheiro com milhas aéreas?"
						icon="airplane-world"
					/>
				);
			case 7: // Credit card NO -> Response YES -> RESULT
				return (
					// FIXME: Go to form
					<LandingPageQuizResultBase
						text="A gente te entende! Você não usa cartão de crédito, mas isso não é um problema. O importante é que você sabe dar valor ao dinheiro e tem potencial para vender milhas."
						strongText="Dá para aproveitar as várias formas que existem hoje para acumular pontos e milhas. Quer ver?"
						buttonText="BAIXE O GUIA COMPLETO DAS MILHAS AÉREAS"
						buttonAction={() => this.goToAverageMiles()}
					/>
				);
			case 8: // Credit card NO -> Response NO -> RESULT
				return (
					// FIXME: Go to form
					<LandingPageQuizResultBase
						text="Que pena! Vender milhas é um mercado que muita gente ainda não conhece, por isso, é natural ficar um pouco desconfiado."
						strongText="A MaxMilhas é líder nesse mercado desde 2013 e você pode confiar na gente! Aqui, além de ter uma renda extra vendendo milhas, você ainda pode fazer outras pessoas viajarem. Vem conhecer um pouco mais do nosso mercado!"
						buttonText="BAIXE O GUIA COMPLETO DAS MILHAS AÉREAS"
						buttonAction={() => this.goToAverageMiles()}
					/>
				);
			case 9: // Credit card YES -> Fidelity Plan NO
				return (
					<LandingPageQuizQuestionBase
						yes={() => this.setCurrentStep(10)}
						no={() => this.setCurrentStep(11)}
						text="Você sabia que pode ganhar dinheiro vendendo suas milhas? E se cadastrar num programa de fidelidade é o primeiro passo para isso. Então, responda pra gente:"
						title="Você gostaria de vender milhas e ganhar dinheiro?"
						icon="airplane-world"
					/>
				);
			case 10: // Credit card NO -> Fidelity Plan NO -> Sale Miles YES
				return (
					// FIXME: Go to form
					<LandingPageQuizResultBase
						text="Legal! A gente vê que você sabe dar valor ao dinheiro e tem um grande potencial para lucrar com suas milhas. Já tem cartão de crédito e só precisa checar se tem pontos no cartão e escolher o programa de fidelidade que mais tem a ver com você."
						strongText="Quer entender mais sobre todo esse processo?"
						buttonText="BAIXE O GUIA COMPLETO DAS MILHAS AÉREAS"
						buttonAction={() => this.goToAverageMiles()}
					/>
				);
			case 11: // Credit card YES -> Fidelity Plan NO -> Sale Miles NO
				return (
					// FIXME: Go to form
					<LandingPageQuizResultBase
						text="Ah, que pena! Mas você já utiliza cartão de crédito, então, nossa dica é que antes de você desistir, você confira se seu cartão acumula milhas. suas milhas na MaxMilhas você pode ter uma renda extra e ainda fazer outras pessoas viajarem."
						strongText="Você já tem milhas no cartão de crédito e conhece os programas de fidelidade. Vale a pena conhecer mais sobre esse jeito fácil e seguro de ganhar dinheiro ;)"
						buttonText="BAIXE O GUIA COMPLETO DAS MILHAS AÉREAS"
						buttonAction={() => this.goToAverageMiles()}
					/>
				);
			case 12: // Credit card NO -> Response NO -> RESULT
				return (
					// FIXME: Go to form
					<LandingPageQuizResultBase
						text="Ah, que pena! A gente acredita que vendendo suas milhas na MaxMilhas você pode ter uma renda extra e ainda fazer outras pessoas viajarem."
						strongText="Você já tem milhas no cartão de crédito e conhece os programas de fidelidade. Vale a pena conhecer mais sobre esse jeito fácil e seguro de ganhar dinheiro ;)"
						buttonText="BAIXE O GUIA COMPLETO DAS MILHAS AÉREAS"
						buttonAction={() => this.goToAverageMiles()}
					/>
				);
			case 13:
				return <LandingPageQuizForm submitted={() => this.submitted()} />;
			default:
				return <h1>Oi</h1>;
		}
	}

	render() {
		return (
			<LandingPageLayout
				classAdd={`offers-landing-page-quiz offers-landing-page-quiz__background--${this.setBackgroundColor()}`}
			>
				<div className="offers-landing-page-quiz__content">{this.getCurrentStepComponent()}</div>
				<div className="offers-landing-page-quiz__container-down-button" onClick={() => this.goDown()}>
					<h4>Confira mais!</h4>
					<button>
						<img src={arrowDown} alt="" />
					</button>
				</div>
			</LandingPageLayout>
		);
	}
}

export default LandingPageQuiz;
